module.exports = __webpack_public_path__ + "img/tag1.dc80dc95.png";